import React, { createContext, useContext, ReactNode } from 'react';
import navigationConfig from '../config/navigation';

// Define the structure of navigation sections
export interface NavigationSection {
  id: string;
  label: string;
  path: string;
  isActive: boolean;
}

interface NavigationContextType {
  sections: NavigationSection[];
}

const NavigationContext = createContext<NavigationContextType | undefined>(undefined);

export const useNavigation = (): NavigationContextType => {
  const context = useContext(NavigationContext);
  if (!context) {
    throw new Error('useNavigation must be used within a NavigationProvider');
  }
  return context;
};

interface NavigationProviderProps {
  children: ReactNode;
}

export const NavigationProvider: React.FC<NavigationProviderProps> = ({ children }) => {
  // Convert config to sections array
  const sections: NavigationSection[] = Object.entries(navigationConfig.sections).map(
    ([id, section]) => ({
      id,
      label: section.label,
      path: section.path,
      isActive: section.enabled
    })
  );

  return (
    <NavigationContext.Provider value={{ sections }}>
      {children}
    </NavigationContext.Provider>
  );
}; 